import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-toggle',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule],
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    },
  ],
})
export class ToggleComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() checked: boolean = false;
  @Input() iconTrue: string = '';
  @Input() iconFalse: string = '';
  @Input() disabled: boolean = false;
  @Output() onChange = new EventEmitter<boolean>();
  @Input() option1: string = '';
  @Input() option2: string = '';

  // Control Value Accessor
  private onChangeCallback: (_: any) => void = () => {};
  private onTouchedCallback: () => void = () => {};

  constructor(public tooltipConfig: NgbTooltipConfig) {
    // Configuración global de tooltips
    this.tooltipConfig.autoClose = true;
    this.tooltipConfig.triggers = 'hover';
    this.tooltipConfig.openDelay = 0;
    this.tooltipConfig.closeDelay = 0;
  }

  /**
   * Toggle el estado del componente
   * @param value - Valor opcional para establecer directamente
   */
  toggle(value?: boolean): void {
    if (this.disabled) return;

    if (value !== undefined) {
      // Si se proporciona un valor, lo usamos directamente
      this.checked = value;
    } else {
      // Si no, invertimos el estado actual
      this.checked = !this.checked;
    }

    this.onChange.emit(this.checked);
    this.onChangeCallback(this.checked);
    this.onTouchedCallback();
  }

  /**
   * Establece el valor del toggle
   * @param value - El valor a establecer
   */
  writeValue(value: any): void {
    if (value !== undefined) {
      this.checked = !!value;
    }
  }

  /**
   * Registra la función de cambio
   * @param fn - Función a ejecutar cuando cambie el valor
   */
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  /**
   * Registra la función de touched
   * @param fn - Función a ejecutar cuando se marque como tocado
   */
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  /**
   * Establece el estado de deshabilitado
   * @param isDisabled - Estado de deshabilitado
   */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
